// Marquoir : comportements légers partagés (accordéons, compteur panier, ajout au panier, annonces).

const mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)');
const POSE = 'cubic-bezier(.2, 0, 0, 1)';
const racineBoutique = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

// ---------- Annonces pour lecteurs d'écran ----------
export function annoncer(texte) {
  let zone = document.getElementById('mq-annonce');
  if (!zone) {
    zone = document.createElement('div');
    zone.id = 'mq-annonce';
    zone.className = 'visuellement-cache';
    zone.setAttribute('aria-live', 'polite');
    zone.setAttribute('aria-atomic', 'true');
    document.body.appendChild(zone);
  }
  zone.textContent = '';
  // Petit délai : force la relecture d'un message identique
  window.setTimeout(() => { zone.textContent = texte; }, 60);
}

// ---------- Accordéons animés (details.mq-accordeon), 200 ms ----------
function initAccordeon(details) {
  const resume = details.querySelector(':scope > summary');
  const contenu = details.querySelector(':scope > .mq-accordeon__contenu');
  if (!resume || !contenu || details.dataset.mqPret) return;
  details.dataset.mqPret = '1';
  let anim = null;

  resume.addEventListener('click', (evt) => {
    if (mouvementReduit.matches || !contenu.animate) return; // comportement natif
    evt.preventDefault();
    if (anim) anim.cancel();
    const duree = 200;
    if (details.open) {
      const h = contenu.offsetHeight;
      anim = contenu.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: duree, easing: POSE });
      anim.onfinish = () => { details.open = false; anim = null; };
    } else {
      details.open = true;
      const h = contenu.offsetHeight;
      anim = contenu.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: duree, easing: POSE });
      anim.onfinish = () => { anim = null; };
    }
  });
}

// ---------- Compteur du panier ----------
async function lirePanier() {
  const rep = await fetch(racineBoutique + 'cart.js', { headers: { Accept: 'application/json' } });
  if (!rep.ok) throw new Error('panier');
  return rep.json();
}

function afficherCompte(n) {
  document.querySelectorAll('[data-mq-panier-compte]').forEach((el) => { el.textContent = String(n); });
}

document.addEventListener('mq:panier-maj', async (evt) => {
  const detail = evt.detail || {};
  if (typeof detail.item_count === 'number') { afficherCompte(detail.item_count); return; }
  try { afficherCompte((await lirePanier()).item_count); } catch (e) { /* le compteur serveur reste affiché */ }
});

// ---------- Fiche : variante (prix) et ajout au panier sans rechargement ----------
function initVariantes(racine = document) {
  racine.querySelectorAll('select[data-mq-variante]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const form = select.form;
      const zone = form && form.closest('[data-mq-produit]');
      if (!option || !zone) return;
      zone.querySelectorAll('[data-mq-prix]').forEach((el) => { el.textContent = option.dataset.prix || el.textContent; });
      zone.querySelectorAll('[data-mq-indisponible]').forEach((el) => { el.hidden = option.dataset.disponible !== 'false'; });
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url);
      }
    });
  });
}

function initAjoutPanier(racine = document) {
  racine.querySelectorAll('form[data-mq-ajout]').forEach((form) => {
    form.addEventListener('submit', async (evt) => {
      if (!window.fetch || !window.FormData) return;
      evt.preventDefault();
      const bouton = form.querySelector('[type="submit"]');
      const erreur = form.querySelector('[data-mq-erreur]');
      const libelle = bouton ? bouton.dataset.libelle || bouton.textContent : '';
      if (erreur) erreur.hidden = true;
      if (bouton) bouton.setAttribute('aria-busy', 'true');
      try {
        const rep = await fetch(racineBoutique + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });
        const donnees = await rep.json();
        if (!rep.ok) throw new Error(donnees.description || donnees.message || '');
        const panier = await lirePanier();
        document.dispatchEvent(new CustomEvent('mq:panier-maj', { detail: { item_count: panier.item_count } }));
        if (bouton) {
          bouton.textContent = bouton.dataset.libelleAjoute || libelle;
          window.setTimeout(() => { bouton.textContent = libelle; }, 2400);
        }
        annoncer(form.dataset.annonceAjoute || bouton?.dataset.libelleAjoute || '');
      } catch (e) {
        if (erreur) {
          const texte = erreur.querySelector('[data-mq-erreur-texte]');
          if (texte) texte.textContent = e.message || texte.dataset.defaut || texte.textContent;
          erreur.hidden = false;
          annoncer(texte ? texte.textContent : '');
        }
      } finally {
        if (bouton) bouton.removeAttribute('aria-busy');
      }
    });
  });
}

function init(racine = document) {
  racine.querySelectorAll('details.mq-accordeon').forEach(initAccordeon);
  initVariantes(racine);
  initAjoutPanier(racine);
}

init();

// Éditeur de thème : réinitialiser les sections rechargées
document.addEventListener('shopify:section:load', (evt) => init(evt.target));

window.Marquoir = window.Marquoir || {};
window.Marquoir.annoncer = annoncer;
